/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import { useEffect } from "react";

export function useOutsideAlerter(ref: any, func: any, delay: number = 0) {
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref && !ref.contains(event.target)) {
				setTimeout(() => {
					func();
				}, delay);
			}
		}
		document.addEventListener("mouseup", handleClickOutside);
		document.addEventListener("contextmenu", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
			document.removeEventListener("contextmenu", handleClickOutside);
		};
		//eslint-disable-next-line
	}, [ref]);
}
